import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Stack } from '@mui/system'
import React from 'react'

interface Props {
  title: string
  breakOnMobile?: boolean
  description?: string
  children?: React.ReactNode
}

/**
 * Wrapper component for actuator options, providing a consistent layout with title, description and the option component itself.
 */
const ActuatorOption: React.FC<Props> = ({ children, title, description, breakOnMobile = true }) => {
  return (
    <Stack
      flexDirection={breakOnMobile ? { xs: 'column', sm: 'row' } : 'row'}
      justifyContent="space-between"
      alignItems={breakOnMobile ? { xs: 'flex-start', sm: 'center' } : 'center'}
      gap={2}
    >
      <Stack gap={1}>
        <Typography variant={'h3'}>{title}</Typography>
        {description && <Typography variant={'body2'}>{description}</Typography>}
      </Stack>
      {children}
    </Stack>
  )
}

export default ActuatorOption
